module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAAAXNSR0IArs4c6QAAAFpJREFUCB1jYIACm6X8gjA2E4hhvVhE/fcvhuUogn///Kll+M/gbrFA0BokwQRS9f///0iwqn//GkA0o8V8gSVAwWiwIEiAicmG0XqRiMlfhv/MMEG2P/+fAQD/xhy14fF6iwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Triangle_gree.png
// module id = rBwH
// module chunks = 3